module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-55-min.3d73d2ea.jpg";